import React, { useState, useEffect } from "react";
import HOC from "../component/HOC";
import BaseUrl from "../BaseUrl";
import axios from 'axios'
import { BiDotsVerticalRounded } from "react-icons/bi";
import { Menu } from '@headlessui/react'
import { saveAs } from "file-saver";
import { FiBarChart2, FiDownload, FiExternalLink, FiFileText, FiShare2 } from "react-icons/fi";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const Report = () => {

    const [data, setData] = useState([]);
    const [isLoadingReports, setIsLoadingReports] = useState(true);

    const getReport = async () => {
        setIsLoadingReports(true);
        const token = localStorage.getItem("authorization")
        var auth = {
            headers: {
                authorization: `bearer ${token}`,
            },
        };
        const url = BaseUrl() + "api/goal/get-my_report";
        try {
            const res = await axios.get(url, auth);
            if (res.data.ResponseCode === 200) {
                setData(res.data.Response);

            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoadingReports(false);
        }
    };

    const dowenloadFile = (row) => {
        window.addEventListener("storage", event => {
            const { newValue, oldValue, key } = event;

            if (key !== "blobUrl") return;

            if (newValue === oldValue) return;

            const blobUrl = row
            saveAs(blobUrl, row);
        });

        return () => {
            window.removeEventListener("storage", function () { });
        };
    };

    useEffect(() => {
        getReport();
    }, []);

    const reportButtonClass =
        'inline-flex items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-sky-500 to-blue-700 px-4 py-2.5 text-sm font-bold text-white shadow-lg shadow-sky-600/20 transition hover:-translate-y-0.5 hover:shadow-xl hover:shadow-sky-700/25 focus:outline-none focus:ring-4 focus:ring-sky-100';

    return (
        <main className="mx-auto flex w-full max-w-7xl flex-col gap-4">
            <section className="relative overflow-hidden rounded-[1.9rem] border border-white/70 bg-gradient-to-br from-sky-500 via-blue-600 to-blue-800 px-4 py-4 text-white shadow-2xl shadow-sky-900/20 sm:px-5">
                <div className="pointer-events-none absolute -right-16 -top-20 h-40 w-40 rounded-full bg-white/20 blur-3xl" />
                <div className="pointer-events-none absolute -bottom-20 left-10 h-36 w-36 rounded-full bg-cyan-300/20 blur-3xl" />
                <div className="relative flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
                    <div>
                        <div className="mb-2 inline-flex items-center gap-2 rounded-full bg-white/15 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-sky-100 ring-1 ring-white/20 backdrop-blur">
                            <FiBarChart2 className="h-3.5 w-3.5" />
                            Reports Dashboard
                        </div>
                        <h1 className="text-xl font-bold tracking-tight sm:text-2xl">My Reports</h1>
                        <p className="mt-1.5 max-w-2xl text-sm leading-5 text-sky-100">
                            View, download, and share progress reports for your goals from one polished workspace.
                        </p>
                    </div>
                    <div className="grid w-full gap-2 rounded-2xl bg-white/15 p-3 ring-1 ring-white/20 backdrop-blur sm:max-w-xs">
                        <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-sky-100">Available Reports</p>
                        <div className="flex items-end justify-between">
                            <span className="text-2xl font-bold">{isLoadingReports ? "..." : data.length}</span>
                            <span className="rounded-full bg-white px-2.5 py-1 text-[11px] font-bold text-blue-700">Ready</span>
                        </div>
                    </div>
                </div>
            </section>

            <section className="rounded-[1.75rem] border border-white/80 bg-white/95 p-4 shadow-xl shadow-sky-900/5 backdrop-blur sm:p-5">
                <div className="mb-4 flex flex-col gap-2 border-b border-slate-100 pb-4 sm:flex-row sm:items-center sm:justify-between">
                    <div>
                        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-sky-600">Report Library</p>
                        <h2 className="mt-0.5 text-xl font-extrabold text-slate-950">Generated goal reports</h2>
                    </div>
                    <span className="w-fit rounded-full bg-sky-50 px-3 py-1 text-[11px] font-bold text-sky-700 ring-1 ring-sky-100">
                        {isLoadingReports ? "Loading..." : `${data.length} total`}
                    </span>
                </div>

                {isLoadingReports ? (
                    <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
                        {Array.from({ length: 6 }).map((_, index) => (
                            <article key={index} className="rounded-3xl border border-slate-200/80 bg-gradient-to-br from-white to-sky-50/70 p-4 shadow-sm">
                                <div className="flex items-start gap-3">
                                    <div className="h-12 w-12 shrink-0 rounded-2xl bg-sky-100 bsi-skeleton" />
                                    <div className="min-w-0 flex-1">
                                        <div className="h-3 w-20 rounded-full bg-sky-100 bsi-skeleton" />
                                        <div className="mt-2 h-5 w-3/4 rounded-full bg-slate-100 bsi-skeleton" />
                                        <div className="mt-2 h-3 w-28 rounded-full bg-slate-100 bsi-skeleton" />
                                    </div>
                                </div>
                                <div className="mt-5 h-12 rounded-2xl bg-white/80 bsi-skeleton" />
                            </article>
                        ))}
                    </div>
                ) : data.length === 0 ? (
                    <div className="rounded-3xl border border-dashed border-sky-200 bg-sky-50/60 p-8 text-center">
                        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-white text-sky-700 shadow-sm">
                            <FiFileText className="h-7 w-7" />
                        </div>
                        <h3 className="mt-4 text-xl font-bold text-slate-900">No reports available yet</h3>
                        <p className="mx-auto mt-2 max-w-md text-sm leading-6 text-slate-500">
                            Reports generated from your goals will appear here for quick viewing and downloads.
                        </p>
                    </div>
                ) : (
                    <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
                        {data.map((item, index) => {
                            return (
                                <article key={item.id || item.goalId || index} className="group rounded-3xl border border-slate-200/80 bg-gradient-to-br from-white to-sky-50/70 p-4 shadow-sm transition-all duration-200 hover:-translate-y-1 hover:border-sky-300 hover:shadow-xl hover:shadow-sky-900/10">
                                    <div className="flex items-start justify-between gap-3">
                                        <div className="flex min-w-0 items-start gap-3">
                                            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-sky-500 to-blue-700 text-white shadow-lg shadow-sky-500/20 ring-2 ring-sky-100">
                                                <FiFileText className="h-6 w-6" />
                                            </span>
                                            <div className="min-w-0">
                                                <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-sky-600">Report {index + 1}</p>
                                                <h3 className="mt-1 truncate text-base font-extrabold text-slate-950 transition group-hover:text-sky-700">
                                                    {item.reportName}
                                                </h3>
                                                <p className="mt-1 text-xs font-semibold text-slate-500">Goal ID: {item.goalId}</p>
                                            </div>
                                        </div>
                                        <Menu as="div" className="relative inline-block text-left">
                                            <Menu.Button
                                                type="button"
                                                className="inline-flex h-9 w-9 items-center justify-center rounded-2xl text-slate-500 transition hover:bg-white hover:text-slate-900 hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-300"
                                                aria-label="More actions"
                                            >
                                                <BiDotsVerticalRounded className="text-2xl" />
                                            </Menu.Button>

                                            <Menu.Items className="absolute right-0 z-20 mt-2 w-48 origin-top-right overflow-hidden rounded-2xl border border-slate-100 bg-white p-1 shadow-2xl shadow-slate-900/10 ring-1 ring-black/5 focus:outline-none">
                                                <Menu.Item>
                                                    {({ active }) => (
                                                        <a
                                                            href={BaseUrl() + "api/goal/generate-pdf/" + item.goalId}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className={classNames(
                                                                active ? 'bg-sky-50 text-sky-700' : 'text-slate-700',
                                                                'flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold transition'
                                                            )}
                                                        >
                                                            <FiExternalLink className="h-4 w-4" />
                                                            View
                                                        </a>
                                                    )}
                                                </Menu.Item>
                                                <Menu.Item>
                                                    {({ active }) => (

                                                        <button
                                                            type="button"
                                                            onClick={() => dowenloadFile(item.pdf)}
                                                            className={classNames(
                                                                active ? 'bg-sky-50 text-sky-700' : 'text-slate-700',
                                                                'flex w-full items-center gap-2 rounded-xl px-4 py-2.5 text-left text-sm font-semibold transition',

                                                            )}
                                                        >
                                                            <FiDownload className="h-4 w-4" />
                                                            Download
                                                        </button>
                                                    )}
                                                </Menu.Item>

                                                <Menu.Item>
                                                    {({ active }) => (
                                                        <span
                                                            className={classNames(
                                                                active ? 'bg-sky-50 text-sky-700' : 'text-slate-700',
                                                                'flex cursor-default items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold transition'
                                                            )}
                                                        >
                                                            <FiShare2 className="h-4 w-4" />
                                                            Share
                                                        </span>
                                                    )}
                                                </Menu.Item>

                                            </Menu.Items>
                                        </Menu>
                                    </div>

                                    <div className="mt-5 flex items-center justify-between rounded-2xl bg-white/80 px-3.5 py-3 ring-1 ring-slate-100">
                                        <div>
                                            <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-slate-400">Status</p>
                                            <p className="text-sm font-bold text-slate-900">Available</p>
                                        </div>
                                        <a
                                            href={BaseUrl() + "api/goal/generate-pdf/" + item.goalId}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={reportButtonClass}
                                        >
                                            <FiExternalLink className="h-4 w-4" />
                                            View report
                                        </a>
                                    </div>
                                </article>
                            )
                        })}
                    </div>
                )}
            </section>
        </main>
    )
}

export default HOC(Report)
